import type { FaireProductEntity } from "../../entity_types/product";

export const p_97zg46rmhh: FaireProductEntity = {
  token: "p_97zg46rmhh",
  type: "product",
  name: "18K NON-TARNISH WATERPROOF STAINLESS STEEL BANGLE | 40B5152",
  brandToken: "b_9j5az29aau",
  brandName: "JOSSLYN by wall to wall",
  imageUrl:
    "https://cdn.faire.com/fastly/1f06bf66e1b3534a5b9249149b15adf9173f099a1f8dad76dd6aae792b0dab92.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/975a1071cd9b02d01e27e61a57db98798d3468069b813fa1330ca94aa6706f62.jpeg",
  ],
  priceDollars: 5.47,
  description:
    "18K Non-Tarnish Waterproof Stainless Steel Real Gold Dipped Half-Round Rhinestone Bangle is crafted from high-quality stainless steel and dipped in real 18K gold, this bangle features a sleek half-round design adorned with sparkling rhinestones for a touch of glamour. Its non-tarnish and waterproof properties ensure long-lasting shine.\n\nProduct Details:\ndiameter: 60mm\nclasp: Hinge\nMetal finish: Stainless Steel 18K Gold, Silver\nproduct: Lead & Nickel Compliant\nanti-tarnish:  Tarnish Free, Non-Tarnish\n\nReal Gold Dipped Bracelet\nStainless Steel Bracelet\nHypoallergenic Bracelet\nTarnish-Free Bracelet\nNon-Tarnish Bracelet\nWater Proof Bracelet\nWater Resistant Bracelet\nSweatproof Jewelry\nFade Resistant Bracelet\nAnti-oxidation \nPVD Coating",
  tags: [],
  msrpDollars: 10.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:57.353Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
